// extracted by mini-css-extract-plugin
export default {"headerwrapper":"header_headerwrapper__jncQ5","header":"header_header__lOwdN","header__navlist":"header_header__navlist__-VPB3"};